export default "__VITE_ASSET__Bm_UQZOe__"